<template>
  <div class="atividade-popup">
    <ul class="atividade-popup-ul">
      <li v-for="e in list" :key="e.id" class="atividade-popup-ul-li" @click="change(e)">
        <div
          :class="[
            'atividade-popup-ul-li--box',
            { active: activeForm.id === e.id },
            { 'un-read': e.unRead },
          ]"
        >
          <template v-if="type === 'atividade'">
            <div class="content-box chxy-row-c-c">
              <van-icon :name="iconType(e.type)" class="atividade-popup-ul-li--box-icon" />
            </div>
          </template>
          <template v-else-if="type === 'site-message'">
            <div class="content-box chxy-row-c-c">
              <img
                v-if="activeForm.id === e.id"
                :src="getImageUrlWithCDN_LOCAL('/home/emial_icon_on.png')"
                class="atividade-popup-ul-li--box-img"
              />
              <img
                v-else
                :src="getImageUrlWithCDN_LOCAL('/home/emial_icon_off.png')"
                class="atividade-popup-ul-li--box-img"
              />
            </div>
          </template>
          <div class="content-box chxy-row-ac">
            <span class="atividade-popup-ul-li--box-title" v-html="e.title"></span>
          </div>
        </div>
      </li>
    </ul>

    <div class="atividade-popup-main">
      <div class="atividade-popup-main-content">
        <img
          v-if="activeForm.img"
          :src="activeForm.img"
          class="atividade-popup-main-content-img"
          @click="jumpUrl(activeForm.jump_url)"
        />
        <div v-else class="atividade-popup-main-content-html" v-html="activeForm.content"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useAtividadeModel } from './js/index.js'

const props = defineProps({
  list: {
    type: Array,
    default: () => [],
  },
  type: {
    type: String,
    default: 'atividade',
  },
  isHasUnRead: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['change', 'close'])

const { activeForm, change, iconType, jumpUrl } = useAtividadeModel(props, emit)

defineExpose({
  change,
  jumpUrl,
})
</script>

<style lang="less" scoped>
@import url('./css/index.less');
</style>
